exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlight {\n  border-radius: 50px;\n  color: #fff;\n  cursor: pointer; }\n  .highlight a {\n    color: #fff; }\n  .map-container {\n  height: 100%; }\n  .map-container .row {\n    height: 100%; }\n  .map-container .row #viewer {\n      width: 100%;\n      height: 100%; }\n  .map-overlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0px;\n  z-index: 100;\n  background: rgba(0, 0, 0, 0.2); }\n  .openseadragon-canvas + div {\n  background: #000; }\n  span.icon-ic_close {\n  position: absolute;\n  top: 0;\n  cursor: pointer;\n  right: 0; }\n  .map-legend {\n  display: none; }\n  .map-legend ul {\n    background: #f1f1f1;\n    border: 1px solid #dadada;\n    -webkit-column-count: 4;\n    -moz-column-count: 4;\n    column-count: 4; }\n  .map-legend ul li {\n      display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/components/map/map.component.scss
// module id = ../../../../../src/app/components/map/map.component.scss
// module chunks = main